const red = 'rgb(193, 39, 45)';
const white = 'white';
const black = 'black';
const offWhite = '#F5F5F5'; // must be set in global CSS also

export const theme = {
	text: {
		primary: {
			color: white,
			active: red
		},
	},
	elements: {
		document: {
			background: offWhite,
		},
		primary: {
			background: black,
			border: red
		},
	},
};


// WEBPACK FOOTER //
// ./src/config/theme.js